import CPFMask from './CPFMask';
import CreditCardCvvMask from './CreditCardCvvMask';
import CreditCardExpirationDateMask from './CreditCardExpirationDateMask';
import CreditCardNumberMask from './CreditCardNumberMask';
import DateMask from './DateMask';
import MoneyMask from './MoneyMask';
import NumberMask from './NumberMask';
import PhoneMask from './PhoneMask';
import ZipCodeMask from './ZipCodeMask';

export { DateMask };
export { PhoneMask };
export { CPFMask };
export { ZipCodeMask };
export { MoneyMask };
export { CreditCardNumberMask };
export { CreditCardExpirationDateMask };
export { CreditCardCvvMask };
export { NumberMask };

export type MaskProps = {
  mask?:
    | 'date'
    | 'phone'
    | 'cpf'
    | 'zipCode'
    | 'money'
    | 'creditCardNumber'
    | 'creditCardExpirationDate'
    | 'creditCardCvv'
    | 'number';
};

export const Masks = {
  cpf: CPFMask,
  date: DateMask,
  phone: PhoneMask,
  zipCode: ZipCodeMask,
  money: MoneyMask,
  creditCardNumber: CreditCardNumberMask,
  creditCardExpirationDate: CreditCardExpirationDateMask,
  creditCardCvv: CreditCardCvvMask,
  number: NumberMask,
};
